export const SHIPPER_SOURCE = {
  CUSTOMER: "MYSQL",
  AS400: "AS400",
}